module.exports = __webpack_public_path__ + "static/media/58.cca31b69.png";